import React, { FC } from "react";
import { motion } from "framer-motion";
import TextRotator from "shared/TextRotater/TextRotater";
import { IClientData } from "Interfaces/interface.home";
import CountUpNumber from "shared/CountUpData/CountUpData";
import { AlarmClockCheck, Gift, Handshake, HeartHandshake } from "lucide-react";
import { environment } from "@/environments/environment";

export const clientData: IClientData[] = [
  {
    id: 1,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/18036855-08e9-4e99-8aa1-194dc999be5b-Kion-Group.png`,
    name: "Kion Group",
  },
  {
    id: 2,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/1845875d-0b14-4bc5-9869-95474afa60b9-MAN.png`,
    name: "MAN",
  },
  {
    id: 3,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/31a63d0b-5e82-45c4-8038-b633348d3e76-CRIF.png`,
    name: "CRIF",
  },
  {
    id: 4,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/327fca16-f903-4401-b636-34a57c10c7dd-Rockwell_Automation.png`,
    name: "Rockwell Automation",
  },
  {
    id: 5,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/61527e7c-a9e0-4b87-93b5-50ec350952a7-Elastic-run.png`,
    name: "Elastic Run",
  },
  {
    id: 6,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/84ca304c-ab45-4825-8743-1d0ad1714df7-Metro.png`,
    name: "Metro",
  },
  {
    id: 7,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/7efe9c4d-77ef-408a-9db2-4f84d9ca9008-Jade-Global.png`,
    name: "Jade Global",
  },
  {
    id: 8,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/731430f0-ad57-4f2f-a635-6a5425b527db-EATON.png`,
    name: "EATON",
  },
  {
    id: 9,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/714de078-d313-45cd-bfc8-f3290fcfb729-Emerson.png`,
    name: "Emerson",
  },
  {
    id: 10,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/6c2fdeaf-b3a3-49b4-90d2-35a63c47e001-Alfa-Laval.png`,
    name: "Alfa Laval",
  },
  {
    id: 11,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/8ca7f495-81c7-4144-9b33-0a69ef013d6b-T-Systems.png`,
    name: "T-Systems",
  },
  {
    id: 12,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/a99078b0-bcd4-485e-81d9-f071e9f601a7-Tata-Autocomp.png`,
    name: "Tata Autocomp",
  },
  {
    id: 13,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/aea42e58-9e7f-4fc0-98f0-93bd64a0635e-Spring.png`,
    name: "Spring",
  },
  {
    id: 14,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/c6414d3c-eec7-45ac-922b-65be380aeeb7-One-Card.png`,
    name: "One Card",
  },
  {
    id: 15,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/c7680b17-2173-44b3-bf4a-6bab28d9eda6-Hyosung.png`,
    name: "Hyosung",
  },
  {
    id: 16,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/f82013a8-579b-4089-9f6b-626a24822ffb-tataBluescoprSteel.png`,
    name: "Tata Bluescope Steel",
  },
  {
    id: 17,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/e5d27e4c-b1e2-41cd-b059-2630b34d8397-Fresenius-Kabi.png`,
    name: "Fresenius Kabi",
  },
  {
    id: 18,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/e5218138-1029-49fe-86c3-554f36c25c08-Arista.png`,
    name: "Arista",
  },
  {
    id: 19,
    img: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/clientImages/d39a7eea-52cd-4567-accc-42948ea1e15e-Roche.png`,
    name: "Roche",
  },
];

const stats = [
  { number: 700, label: "Clients Trusted", icon: Handshake, suffix: "+" },
  { number: 2400, label: "Orders Delivered", icon: Gift, suffix: "+" },
  {
    number: 30,
    label: "Avg. Response Time",
    icon: AlarmClockCheck,
    suffix: " mins",
  },
  {
    number: 87,
    label: "Repeat Client Rate",
    icon: HeartHandshake,
    suffix: "%",
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.4,
    },
  },
};

const statVariants = {
  hidden: { opacity: 0, y: -50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut" as const,
    },
  },
};

const SectionOurClients: FC = () => {
  return (
    <section className="px-4 container mx-auto space-y-10">
      <div className="px-0 overflow-hidden">
        {/* Heading */}
        <div className="text-center">
          <TextRotator />
        </div>
        {/* Carousel Section */}
        <div className="relative w-full overflow-hidden">
          <div className="absolute left-0 top-0 h-full w-16 md:w-20 lg:w-56 xl:w-56 bg-gradient-to-r from-white lg:via-white to-transparent z-10 pointer-events-none" />

          <div className="absolute right-0 top-0 h-full w-16 md:w-20 lg:w-56 xl:w-56 bg-gradient-to-l from-white lg:via-white to-transparent z-10 pointer-events-none" />

          {/* Scrolling logos */}
          <motion.div
            className="flex gap-12 w-max will-change-transform"
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              repeat: Infinity,
              duration: 30,
              ease: "linear" as const,
            }}
          >
            {[...clientData, ...clientData].map((client, index) => (
              <motion.div
                key={index}
                className="flex items-center justify-center min-w-[120px] max-w-[120px] md:min-w-[160px] md:max-w-[200px]"
              >
                <img
                  src={client.img}
                  alt={client.name}
                  className="w-full object-contain grayscale hover:grayscale-0 transition duration-300 hover:-translate-y-2"
                  loading="lazy"
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
        {/* Trust Stats Section */}
        <section className="py-16 relative md:mt-10">
          <div className="max-w-6xl mx-auto px-4">
            <motion.div
              className="grid grid-cols-2 md:grid-cols-4 gap-8"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.4 }}
            >
              {stats.map((stat, index) => {
                const IconComponent = stat.icon;

                return (
                  <motion.div
                    key={index}
                    className="text-center group"
                    variants={statVariants}
                  >
                    <motion.div
                      className="relative w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 mx-auto mb-4 flex items-center justify-center overflow-hidden"
                      whileHover="hover"
                      initial="initial"
                      animate="initial"
                      variants={{
                        hover: { scale: 1.05 },
                        initial: { scale: 1 },
                      }}
                    >
                      <IconComponent className="h-8 w-8 text-white z-10 relative" />

                      <motion.div
                        className="absolute top-0 left-[-65%] w-[30%] h-full bg-white/60 z-20 pointer-events-none"
                        style={{ rotate: "0deg" }}
                        variants={{
                          hover: {
                            left: "100%",
                            transition: {
                              duration: 0.4,
                              ease: "easeInOut" as const,
                            },
                          },
                        }}
                      />
                    </motion.div>

                    <div className="text-3xl font-bold text-gray-900 mb-1">
                      <CountUpNumber to={stat.number} suffix={stat.suffix} />
                    </div>
                    <div className="text-gray-600 text-sm font-medium">
                      {stat.label}
                    </div>
                  </motion.div>
                );
              })}
            </motion.div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default SectionOurClients;
